import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDateInput } from "../../Common/Utils/dateUtils";

const DatesSelect = ({ setParams }) => {


  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // const handleDateChange = (update) => {
  //   setDateRange(update);
  //   setParams((prev) => ({
  //     ...prev,
  //     start_date: update[0] ? formatDateInput(update[0]) : "",
  //     end_date: update[1] ? formatDateInput(update[1]) : "",
  //   }));
  // };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    setParams((prev)=>({
      ...prev,
      start_date: start ? formatDateInput(start) : null,
      end_date: end ? formatDateInput(end) : null,
    }))
  };

  return (
    <DatePicker
      className="custom-datepicker"
      selected={startDate}
      onChange={handleDateChange}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      dateFormat="dd MMM yyyy"
      placeholderText="Select Date Range"
      showYearDropdown // ✅ Enables year selection
      scrollableYearDropdown // ✅ Allows scrolling through years
      yearDropdownItemNumber={100}
    />
  );
};

export default DatesSelect;
